import React from 'react';
import { connect } from 'react-redux';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

import { saveConfig, updateShowNavigator } from './Filter/FilterActions';
import zoomOnIcon from '../assets/img/magnifier-on-01.svg';

export function ZoomControlButton({ navigator, toggle }) {
  const tooltip = (
    <Tooltip id="flowstats-tooltip" className="tooltip_white">
      {navigator ? 'Hide' : 'Show'} zoom control
    </Tooltip>
  );
  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <Button
        name="showNavigator"
        variant='secondary'
        size='sm'
        className={`btn-action chart-zoom-control ${navigator ? 'active' : ''}`}
        onClick={() => toggle(!navigator)}
      >
        <img src={zoomOnIcon} alt="#" />
      </Button>
    </OverlayTrigger>
  );
}

const mapStateToProps = (state, ownProps) => {
  const chart = ownProps.chart || state.filters.chart;
  return {
    navigator: state.filters[chart].showNavigator
  };
};

const mapDispatchToProps = dispatch => ({
  toggle: enabled => {
    dispatch(updateShowNavigator(enabled));
    dispatch(saveConfig());
    setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ZoomControlButton);
